import { Link } from "@tanstack/react-router";

import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";
import { AccountMenu } from "./AccountMenu";
import { useNavGroups, useNavLabel } from "./navConfig";
import { useCurrentPath } from "./useRouteTitle";

export interface NavSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** The phone "More" sheet: the whole config as a flat list under group headers. */
export function NavSheet({ open, onOpenChange }: NavSheetProps) {
  const groups = useNavGroups();
  const label = useNavLabel();
  const current = useCurrentPath();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="max-h-[85vh] overflow-y-auto">
        <SheetHeader className="flex-row items-center justify-between">
          <SheetTitle className="type-subhead">Menu</SheetTitle>
          <AccountMenu align="end" />
        </SheetHeader>
        <div className="flex flex-col gap-md px-md pb-lg">
          {groups.map((group) => (
            <div key={group.id} className="flex flex-col">
              {group.label ? (
                <div className="type-caption pb-xs text-muted-foreground uppercase">
                  {group.label}
                </div>
              ) : null}
              {group.items
                .flatMap((item) => (item.children ? item.children : [item]))
                .map((item) => {
                  const Icon = item.icon;
                  const active = current === item.path;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={() => onOpenChange(false)}
                      className={`type-body flex min-h-11 items-center gap-sm rounded-sm px-sm ${
                        active ? "bg-accent font-medium text-accent-foreground" : "text-foreground"
                      }`}
                    >
                      <Icon className="size-5 shrink-0" />
                      <span>{label(item)}</span>
                    </Link>
                  );
                })}
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
